import Tooltip from '@mui/joy/Tooltip';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import SyncProblemRoundedIcon from '@mui/icons-material/SyncProblemRounded';
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';

export function WidgetSyncIcon(props) {
    return (<>
        {props.hasOwnProperty('synced') && (<>
            {!props?.syncing && (<>
              {props.synced === true && (
                <Tooltip title={'Saved'}>
                  <CheckRoundedIcon fontSize='small' />
                </Tooltip>
              )}
              {props.synced !== true && (
                <Tooltip title={'Needs to save'}>
                  <SyncProblemRoundedIcon fontSize='small' />
                </Tooltip>
              )}
            </>)}
            {!!props?.syncing && (<>
              <Tooltip title={'Saving...'}>
                <CachedRoundedIcon fontSize='small' sx={{animation: 'spin 5s infinite'}} />
              </Tooltip>
            </>)}

          </>)}
    </>);
}
